/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import { Button, Input, ModalBody, User, ModalHeader, Select, SelectItem, Spinner, Pagination } from '@nextui-org/react';
import toast from 'react-hot-toast';
// import { UsersService } from '../../../services';
import { IconBook, IconEdit, IconTrash, IconUsers } from '@tabler/icons-react';
import { useSelector } from 'react-redux';
import { SchoolService, TeacherGroupService } from '../../../../services';
import { classNames, isNumber, fromPhotos, Constants } from '../../../../utils';


const STEP = {
  SUBJECTS: 1,
  STUDENTS: 2,
}

const TYPE_QUALIFICATION_OPTIONS = [
  { key: String(Constants.SUBJECTS.TYPE_QUALIFICATION.QUANTITATIVE), label: 'Cuantitativa' },
  { key: String(Constants.SUBJECTS.TYPE_QUALIFICATION.QUALITATIVE), label: 'Cualitativa' },
];


const ModalCreateGrade = ({ item, onSuccess, onClose }) => {
  const [step, setStep] = useState(STEP.SUBJECTS);
  const [subjectData, setSubjectData] = useState({
    school_year: null,
    grade: null,
    subjects: [],
    sections: [],
  });


  const nextStep = (grade, subjects, sections, school_year) => {
    setStep(STEP.STUDENTS);
    setSubjectData({ grade, subjects, sections, school_year });
  }

  const prevStep = () => {
    if (step === STEP.SUBJECTS) return;
    setStep(STEP.SUBJECTS);
  }

  return (
    <>
      <ModalHeader className="flex flex-col gap-1">{!!item ? 'Editar' : 'Nuevo'}</ModalHeader>
      <ModalBody className="gap-8 relative p-0">
        <div className={`flex items-center justify-center gap-4 w-full `}>
          <div className='flex flex-col items-center cursor-pointer' onClick={prevStep}>
            <div className='w-12 h-12 p-3 rounded-full border-primary border flex justify-center items-center'>
              <IconBook className="w-full h-full object-cover text-primary" />
            </div>
            <p className='text-sm font-bold text-primary'>Materias</p>
          </div>

          <div className='border border-gray w-20 mx-10'></div>

          <div className='flex flex-col items-center'>
            <div className={classNames(
              step === STEP.STUDENTS ? 'border-primary' : 'border-gray',
              'w-12 h-12 p-3 rounded-full border flex justify-center items-center'
            )}>
              <IconUsers className={classNames(
                step === STEP.STUDENTS ? 'text-primary' : 'text-gray',
                'w-full h-full object-cover'
              )} />
            </div>
            <p className={classNames(
              step === STEP.STUDENTS ? 'text-primary' : 'text-gray',
              'text-sm font-bold'
            )}>Asignar estudiantes</p>
          </div>
        </div>


        {step === STEP.SUBJECTS && <SubjectStep nextStep={nextStep} item={item} subjectData={subjectData} />}
        {step === STEP.STUDENTS && <StudentsStep subjectData={subjectData} onSuccess={onSuccess} item={item} />}

      </ModalBody>
    </>
  )
}


const SubjectStep = ({ nextStep, item, subjectData }) => {
  const user = useSelector((state) => state.user)
  const [canFetch, setCanFetch] = useState(true);
  const [form, setForm] = useState({
    school_year: '',
    grade: '',
    _subjectId: null,
    _subjectName: '',
    _subjectCode: '',
    _subjectHours: '',
    _subjectType_qualification: '',
  });

  const [subjects, setSubjects] = useState([]);
  const [schoolYears, setSchoolYears] = useState([]);
  const [grades, setGrades] = useState([])
  const [sections, setSections] = useState([]);
  const [isEditing, setIsEditing] = useState(false);


  useEffect(() => {
    if (!form.grade) return;
    getSections()
  }, [form.grade])

  useEffect(() => {
    getSchoolYears();
  }, [])


  useEffect(() => {
    if (!item) return;
    setForm(s => ({
      ...s,
      school_year: item.school_year_id ? String(item.school_year_id) : '',
      grade: item.school_grade_id ? String(item.school_grade_id) : '',
    }))

    setSubjects(item.subjects.map(x => ({
      id: x.id,
      subject_name: x.name,
      code: x.code,
      hours: +x.hours,
      type_qualification: x.type_qualification,
    })))

  }, [item])

  useEffect(() => {
    if (subjectData.school_year === null || subjectData.grade === null) return;
    setForm(s => ({
      ...s,
      school_year: subjectData.school_year ? String(subjectData.school_year) : '',
      grade: subjectData.grade ? String(subjectData.grade?.id) : '',
    }))

    setSubjects(subjectData.subjects.map(x => ({
      id: x.id,
      subject_name: x.subject_name,
      code: x.code,
      hours: +x.hours,
      type_qualification: x.type_qualification,
    })))

  }, [subjectData])

  const onChange = (value, target) => {
    if (target === '_subjectHours' && !isNumber(value)) return;
    setForm(s => ({ ...s, [target]: value }));
  }

  const addSubject = () => {
    const findSubjectName = subjects.find(x => x.subject_name?.trim()?.toLowerCase() === form._subjectName?.trim()?.toLowerCase());

    if (findSubjectName) {
      setSubjects(subjects.map(x => {
        if (x.subject_name?.trim()?.toLowerCase() === form._subjectName?.trim()?.toLowerCase()) {
          return {
            subject_name: form._subjectName,
            code: form._subjectCode,
            hours: +form._subjectHours,
            type_qualification: form._subjectType_qualification
          }
        }
        return x
      }))
    } else {
      setSubjects([
        ...subjects,
        {
          id: null,
          subject_name: form._subjectName,
          code: form._subjectCode,
          hours: +form._subjectHours,
          type_qualification: form._subjectType_qualification
        }
      ]);
    }

    setIsEditing(false)
    setForm(s => ({
      ...s,
      _subjectName: '',
      _subjectCode: '',
      _subjectHours: '',
      _subjectType_qualification: '',
    }));
  }

  const toSelect = (items) => items.map(x => ({ ...x, value: String(x.id), label: x.name }));

  const getSchoolYears = async () => {
    if (!canFetch) return;
    setCanFetch(false);
    try {
      const dataFilters = { user_id: user.id, professor_id: user.id }
      if (!item) dataFilters.without_subjects = true
      const gradesData = await TeacherGroupService.groups.getGrades(dataFilters);
      const schoolYears = await SchoolService.schoolAdmin.getSchoolarsYears();
      setSchoolYears(toSelect(schoolYears));
      setGrades(toSelect(gradesData));
      setCanFetch(true);

    } catch (error) {
      toast.error(String(error) || 'Ocurrió un error inesperado');
    } finally {
      setCanFetch(true);
    }
  }

  const getSections = async () => {
    try {
      setCanFetch(false);
      const sectionsData = await TeacherGroupService.groups.getSections({ user_id: user.id, school_grade_id: +form.grade });
      setSections(toSelect(sectionsData));
      setCanFetch(true);
    } catch (error) {
      toast.error(String(error) || 'Ocurrió un error inesperado');
      setCanFetch(true);
    }
  }

  const removeSubject = (index, id) => {
    if (id) {
      onDeleteSubject(id)
      return
    }
    setSubjects(subjects.filter((_, idx) => index !== idx));
  }

  const onNext = () => {
    const grade = grades.find(x => +x.value === +form.grade);
    nextStep(grade, subjects, sections, form.school_year)
  }

  const onSubjectEdit = (subject) => {
    setIsEditing(true);
    setForm({
      ...form,
      _subjectId: subject.id,
      _subjectName: subject.subject_name,
      _subjectHours: String(subject.hours),
      _subjectCode: subject.code,
      _subjectType_qualification: subject.type_qualification,
    });
  }

  const onCancelEdit = () => {
    setIsEditing(false);
    setForm({
      ...form,
      _subjectId: null,
      _subjectName: '',
      _subjectHours: '',
      _subjectCode: '',
      _subjectType_qualification: '',
    });
  }

  const onRegisterSubject = async () => {
    try {
      if (form._subjectId) {
        const editSubjectData = {
          id: form._subjectId,
          school_grade_id: +form.grade,
          subject_name: form._subjectName,
          code: form._subjectCode,
          hours: form._subjectHours,
          type_qualification: form._subjectType_qualification,
        }
        await TeacherGroupService.groups.updateSubject(editSubjectData)
        toast.success('Materia editada correctamente')
        setSubjects(subjects.map(x => {
          if (x.id === form._subjectId) {
            return {
              subject_name: form._subjectName,
              code: form._subjectCode,
              hours: +form._subjectHours,
              type_qualification: form._subjectType_qualification,
            }
          }
          return x
        }))
        return
      }
      const subjectsData = {
        professor_id: user.id,
        school_grade_id: +form.grade,
        subjects: [{
          subject_name: form._subjectName,
          code: form._subjectCode,
          hours: form._subjectHours,
          type_qualification: form._subjectType_qualification,
        }]
      }
      await TeacherGroupService.groups.createSubjects(subjectsData);
      toast.success('Materia guardada correctamente')
      addSubject()
    } catch (error) {
      toast.error(String(error) || 'Error al registrar la materia');
    }
  }


  const onDeleteSubject = async (id) => {
    try {
      await TeacherGroupService.groups.deleteSubject({ id });
      toast.success('Materia eliminada correctamente')
      setSubjects(subjects.filter(x => x.id !== id))
    } catch (error) {
      toast.error(String(error) || 'Error al eliminar la materia');
    }
  }

  return (
    <div>
      {/* px-6 py-2 */}
      {
        !canFetch && <div className='absolute w-full h-full inset-0 z-[70] flex justify-center items-center bg-white/30'>
          <Spinner />
        </div>
      }
      <div className='flex items-end justify-between px-6'>
        <div className='flex items-center gap-4'>
          <Select
            label="Año escolar"
            labelPlacement="outside"
            placeholder="Seleccione"
            variant="bordered"
            className='w-[20rem]'
            radius="sm"
            classNames={{ label: 'font-semibold' }}
            disallowEmptySelection={true}
            selectedKeys={!!form.school_year ? [form.school_year] : []}
            onSelectionChange={v => onChange(v.currentKey, 'school_year')}
            isDisabled={!!item}
          >
            {schoolYears.map((item) => (
              <SelectItem key={item.value} value={item.value}>
                {item.label}
              </SelectItem>
            ))}
          </Select>
          <Select
            label="Grado"
            labelPlacement="outside"
            placeholder="Seleccione"
            variant="bordered"
            className='w-[20rem]'
            radius="sm"
            classNames={{ label: 'font-semibold' }}
            disallowEmptySelection={true}
            selectedKeys={!!form.grade ? [form.grade] : []}
            onSelectionChange={v => onChange(v.currentKey, 'grade')}
            isDisabled={!!item}
          >
            {grades.filter(x => x.school_year_id === +form.school_year).map((item) => (
              <SelectItem key={item.value} value={item.value}>
                {item.label}
              </SelectItem>
            ))}
          </Select>
        </div>

        <Button
          className="bg-green"
          color="primary"
          isDisabled={subjects.length === 0 || !form.grade}
          onClick={onNext}
        >
          Siguiente
        </Button>
      </div>

      <div className='px-6 mt-4'>
        <div className='flex gap-2'>
          {sections.map((section) => (
            <p key={section.id} className='bg-primary text-white p-2 rounded-lg text-sm'>
              {section.name}
            </p>
          ))}
        </div>
      </div>

      {/* Campos de entrada en dos columnas */}
      <div className='bg-gray/10 mt-4 pb-3'>
        <div className='grid grid-cols-2 gap-4 p-6'>
          <Input
            label="Nombre de la materia"
            labelPlacement="outside"
            className="col-span-1"
            placeholder="Nombre"
            radius="sm"
            variant="bordered"
            value={form._subjectName}
            onValueChange={v => onChange(v, '_subjectName')}
          />
          <Input
            label="Código de la materia"
            labelPlacement="outside"
            className="col-span-1"
            placeholder="Escribir"
            radius="sm"
            variant="bordered"
            value={form._subjectCode}
            onValueChange={v => onChange(v, '_subjectCode')}
          />
          <Input
            label="Horas semanales"
            labelPlacement="outside"
            className="col-span-1"
            placeholder="Escribir"
            radius="sm"
            variant="bordered"
            value={form._subjectHours}
            onValueChange={v => onChange(v, '_subjectHours')}
          />
          <Select
            label="Tipo de calificación"
            labelPlacement="outside"
            className="col-span-1"
            placeholder=" "
            variant="bordered"
            radius="sm"
            classNames={{ label: 'font-semibold' }}
            disallowEmptySelection={true}
            selectedKeys={form._subjectType_qualification ? [String(form._subjectType_qualification)] : []}
            onSelectionChange={(v) => onChange(v.currentKey, '_subjectType_qualification')}
          >
            {TYPE_QUALIFICATION_OPTIONS.map((opt) => (
              <SelectItem key={opt.key} value={opt.key}>
                {opt.label}
              </SelectItem>
            ))}
          </Select>
        </div>
        <div className='flex justify-center gap-2'>
          {isEditing && (
            <Button
              variant="flat"
              className='text-danger'
              onClick={onCancelEdit}
              isDisabled={!form._subjectName || !form._subjectCode || !form._subjectHours || !form._subjectType_qualification}
            >
              Cancelar edición
            </Button>
          )}
          <Button
            variant="flat"
            className='text-primary'
            onClick={() => !item ? addSubject() : onRegisterSubject()}
            isDisabled={!form._subjectName || !form._subjectCode || !form._subjectHours || !form._subjectType_qualification}
          >
            {isEditing ? 'Editar' : 'Agregar'}
          </Button>
        </div>
      </div>


      <div>
        {subjects.length > 0 && (
          <div className='px-6 py-2 grid grid-cols-4 gap-4 bg-black/70 text-white'>
            <p>Nombre</p>
            <p>Código</p>
            <p>Horas</p>
            <p>Calificación</p>
          </div>
        )}
        {subjects.map((subject, index) => (
          <div className='bg-gray/10 p-2 px-6 rounded-lg relative' key={index}>
            <div className='grid grid-cols-4 gap-4'>
              <p>{subject.subject_name}</p>
              <p>{subject.code}</p>
              <p>{subject.hours}</p>
              <p>
                {subject.type_qualification == Constants.SUBJECTS.TYPE_QUALIFICATION.QUALITATIVE
                  ? 'Cualitativa'
                  : subject.type_qualification == Constants.SUBJECTS.TYPE_QUALIFICATION.QUANTITATIVE
                    ? 'Cuantitativa'
                    : ''}
              </p>
            </div>
            <div className='flex items-center gap-2 absolute top-2 right-6'>
              <IconEdit className='cursor-pointer' onClick={() => onSubjectEdit(subject)} />
              <IconTrash className='cursor-pointer' onClick={() => removeSubject(index, subject.id)} />
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

const StudentsStep = ({ subjectData, onSuccess, item }) => {
  const initialFilters = {
    page: 1,
    perPage: Constants.PER_PAGE,
    search: '',
    school_grade_id: undefined
  };
  const initialPagination = {
    page: 1,
    pages: 1,
    total: 0,
    perPage: Constants.PER_PAGE,
  };


  const { grade, sections, subjects } = subjectData;
  const user = useSelector((state) => state.user);
  const [filters, setFilters] = useState(initialFilters);
  const [pagination, setPagination] = useState(initialPagination);
  const [canFetch, setCanFetch] = useState(true);
  const [students, setStudents] = useState([]);
  const [selectedSection, setSelectedSection] = useState(sections.length > 0 ? String(sections[0].id) : null);
  const [selectedStudents, setSelectedStudents] = useState(new Map());

  const debounceTime = 500;
  const debounce = useRef();

  useEffect(() => {
    getData();
  }, [filters]);

  const getData = async () => {

    if (!canFetch) return;
    setCanFetch(false);
    try {
      const dataFilters = { ...filters, user_id: user.id, school_grade_id: subjectData.grade?.id }

      const response = await TeacherGroupService.groups.getUnassignedStudents(dataFilters);
      const { data, ...rest } = response;

      setPrevStudents(data)
      setStudents(data);
      setPagination(rest);
      setCanFetch(true);
    } catch (error) {
      toast.error(String(error) || "Ocurrió un error inesperado");
      setCanFetch(true);
    }
  };

  const setPrevStudents = (data) => {
    if (!subjectData.grade?.id) return
    const preselected = new Map(selectedStudents); // Clonar estado previo
    data.forEach(student => {
      if (student.section?.id) { // Si el estudiante ya tiene una sección
        if (!preselected.has(String(student.section.id))) {
          preselected.set(String(student.section.id), new Set());
        }
        preselected.get(String(student.section.id)).add(student.id);
      }
    });

    setSelectedStudents(preselected);
  }


  const toggleStudentSelection = (studentId) => {
    setSelectedStudents((prev) => {
      const updated = new Map(prev);
      const sectionStudents = new Set(updated.get(selectedSection) || []);

      if (sectionStudents.has(studentId)) {
        sectionStudents.delete(studentId);
      } else {
        sectionStudents.add(studentId);
      }

      updated.set(selectedSection, sectionStudents);
      return updated;
    });
  };

  const studentsForCurrentSection = students.filter(
    (student) =>
      ![...selectedStudents.values()].some((set) => set.has(student.id)) ||
      selectedStudents.get(selectedSection)?.has(student.id)
  );

  const getCurrentPagination = () => {
    let pag;
    setPagination(s => {
      pag = s;
      return s;
    });
    return pag;
  }

  const goToPage = (page) => {
    const pagination = getCurrentPagination();
    if (page >= 1 && page <= pagination.pages && page !== pagination.page) {
      setCanFetch(true);
      setFilters({ ...filters, page });
    }
  }

  const filterBy = (value, target) => {
    if (debounce.current) clearTimeout(debounce.current);
    debounce.current = setTimeout(() => {
      setCanFetch(true);
      setFilters({ ...filters, page: 1, [target]: value });
    }, debounceTime);
  }


  const onSubmit = async () => {
    if (!canFetch) return;
    setCanFetch(false);
    try {
      const assignments = [...selectedStudents].flatMap(([key, values]) =>
        [...values].map(value => ({ school_section_id: +key, student_id: value, professor_id: user.id }))
      );

      const assignamentsData = {
        professor_id: user.id,
        school_grade_id: +grade.id,
        assignments
      }

      const subjectsData = {
        professor_id: user.id,
        school_grade_id: +grade.id,
        subjects
      }

      await TeacherGroupService.groups.assignSections(assignamentsData);

      // Llamar sólo cuando se crea, no cuando se edita
      if (!item) {
        await TeacherGroupService.groups.createSubjects(subjectsData);
      }
      setCanFetch(true);

      item ? toast.success('Asignaciones editadas correctamente') : toast.success('Aisgnaciones y Materias guardadas correctamente');
      onSuccess()
    } catch (error) {
      setCanFetch(true);
      toast.error(String(error) || "Ocurrió un error inesperado");
    }
  }

  return (
    <div className='pb-5'>
      {
        !canFetch && <div className='absolute w-full h-full inset-0 z-[70] flex justify-center items-center bg-white/30'>
          <Spinner />
        </div>
      }
      <p className="capitalize px-6 font-bold text-gray">{grade?.label}</p>
      <div className='flex items-end justify-between px-6 mt-4'>
        <Input
          label=""
          labelPlacement="outside"
          placeholder="Nombre del estudiante"
          className='w-[20rem]'
          radius="sm"
          variant="bordered"
          onValueChange={v => filterBy(v, 'search')}
        />

        <Button
          className="bg-green"
          color="primary"
          onClick={onSubmit}
        >
          Guardar
        </Button>
      </div>
      <div className="px-6 mt-4 flex gap-2">
        {sections.map((section) => (
          <p
            key={section.id}
            className={classNames(
              selectedSection === String(section.id)
                ? "bg-primary text-white"
                : "bg-white",
              "p-2 rounded-lg text-sm cursor-pointer"
            )}
            onClick={() => setSelectedSection(String(section.id))}
          >
            {section.name}
          </p>
        ))}
      </div>

      <div className="px-6 py-2 grid grid-cols-[1.5fr_1fr_1fr] gap-4 bg-black/70 text-white mt-8">
        <p>Estudiantes</p>
        <p>DNI/C.I</p>
        <p>Teléfono</p>
      </div>

      {studentsForCurrentSection.map((student) => (
        <div
          key={student.id}
          className="grid grid-cols-[1.5fr_1fr_1fr] gap-4 items-center border-b border-foreground-300"
        >
          <div className="bg-foreground-200 flex items-center gap-4 px-6 py-4">
            <div
              className={classNames(
                "w-4 h-4 rounded-full border-1 cursor-pointer",
                selectedStudents.get(selectedSection)?.has(student.id)
                  ? "bg-green border-green"
                  : "bg-foreground-300 border-foreground-400"
              )}
              onClick={() => toggleStudentSelection(student.id)}
            />
            <User
              avatarProps={{
                showFallback: true,
                radius: "full",
                src: student?.photo ? fromPhotos(student?.photo) : null,
              }}
              name={student?.fullname}
              classNames={{ description: "text-foreground-500" }}
            />
          </div>
          <p className="h-fit">{student?.document_type?.name}{student?.document}</p>
          <p>{student?.phonecode?.name}{student?.phone}</p>
        </div>
      ))}

      <div className="flex w-full justify-center mt-4">
        <Pagination
          showControls
          variant="bordered"
          page={pagination.page}
          total={pagination.pages}
          onChange={goToPage}
        />
      </div>
    </div>
  );
};



export default ModalCreateGrade;
